import React from 'react';
import { LayersIcon } from 'lucide-react';
import { RuleScope } from '../../types/commission';
import { Card } from '../sf/Card';
import { NewBadge } from '../sf/NewBadge';
import { ScopeBadge } from '../sf/ScopeBadge';
const levels: {
  scope: RuleScope;
  note: string;
}[] = [{
  scope: 'Employee',
  note: 'Wins when the loan’s LO matches'
}, {
  scope: 'Branch',
  note: 'Branch / Channel — used when no Employee rule matches'
}, {
  scope: 'Default',
  note: 'Plan default — fallback'
}];
export function PrecedenceCard() {
  return <Card title="Rule precedence" icon={LayersIcon} iconBg="#5A1BA9" meta="Employee > Branch/Channel > Plan default" actions={<NewBadge data-id="element-137" data-mp="27e6sfh668b0" />} data-id="element-136" data-mp="gxvcib0u7kdp">
      <p className="mb-2 text-xs text-sf-weak" data-id="element-138" data-mp="78lekejbb7ho">Rule priority is a proposed rebuild feature — main has no rule precedence today.</p>
      <ol className="space-y-2" data-id="element-139" data-mp="ux4qr55hg4f1">
        {levels.map((level, index) => <li key={level.scope} className="flex items-center gap-2.5" data-id="element-140" data-mp="zomid2lm8snc" data-mpi={index}>
            <span className="w-4 text-xs font-semibold text-sf-weak" data-id="element-141" data-mp="zqpfs7p3lo23">{index + 1}</span>
            <ScopeBadge scope={level.scope} data-id="element-142" data-mp="wsyatb4chivr" />
            <span className="text-xs text-sf-weak" data-id="element-143" data-mp="ru52dx3x0i2g">{level.note}</span>
          </li>)}
      </ol>
      <p className="mt-3 flex items-center gap-2 border-t border-sf-border pt-2.5 text-xs text-sf-weak" data-id="element-144" data-mp="15l9wyksfek5x">
        <ScopeBadge scope="Comp Type" data-id="element-145" data-mp="10u1pvvekjavx" />
        Divisor chosen by comp type + product, and by Rate Lock Date vs the branch cutoff (Miami 2026-09-01, others 2026-09-22)
      </p>
    </Card>;
}